import getKind from 'kind-of'

export function isObject(obj: any): obj is Record<keyof any, any> {
  return getKind(obj) === 'object'
}

export function isArray(arr: any): arr is any[] {
  return getKind(arr) === 'array'
}

export function isDate(obj: any) {
  return getKind(obj) === 'date'
}

export function isNumber(obj: any) {
  return getKind(obj) === 'number'
}

export function isBoolean(obj: any) {
  return getKind(obj) === 'boolean'
}

export function isString(obj: any) {
  return getKind(obj) === 'string'
}

export function isFunction(obj: any) {
  return getKind(obj) === 'function'
}

export function typeForDisplay(obj: any) {
  return upperCaseFirst(getKind(obj))
}

export function isUndefined(obj: any) {
  return getKind(obj) === 'undefined'
}

export function isNull(obj: any) {
  return getKind(obj) === 'null'
}

function upperCaseFirst(str: any) {
  if (!isString(str)) {
    return str
  }
  const first = str.slice(0, 1).toUpperCase()
  const rest = str.slice(1, str.length)
  return first + rest
}
